module.exports = __webpack_public_path__ + "static/media/mf.5b9ff36c.svg";